import { createRouter, createWebHistory } from 'vue-router'
import customizedRoute from './customized' 



const routes = [
  {
    path: '/',
    name: 'layout',
    component: () => import(/* webpackChunkName: "layout" */'@/views/manage/layout'),
    redirect: '/designList'
  }, {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/manage/login'),
  }, {
    path: '/design',
    name: 'design',
    component: () => import(/* webpackChunkName: "design" */ '@/views/designer/index.vue'),
  }, {
    path: '/preview',
    name: 'preview',
    component: () => import(/* webpackChunkName: "preview" */ '@/views/preview/index'),

  }, {
    path: '/v/:id',
    name: 'publicView',
    component: () => import(/* webpackChunkName: "publicView" */ '@/views/preview/index'),

  }, {
    path: '/drawarea/:id?',
    name: 'drawarea',
    component: () => import(/* webpackChunkName: "drawarea" */ '@/views/baidu/DrawArea'),

  }, {
    path: '/realtime-position/:id?',
    name: 'realtime-position',
    component: () => import(/* webpackChunkName: "realtime-position" */ '@/views/baidu/RealtimePosition'),

  }, 
  // {
  //   path: '/report-editor',
  //   name: 'report-editor',
  //   component: () => import(/* webpackChunkName: "report-editor" */ '@/views/designer/report-editor'),

  // },
  {
    path: '/report-preview',
    name: 'report-preview',
    component: () => import(/* webpackChunkName: "report-preview" */ '@/views/preview/report-view'),

  },
  {
    path: '/report-v/:id?',
    name: 'reportPublicView',
    component: () => import(/* webpackChunkName: "reportPublicView" */ '@/views/preview/report-view'),
  },
  {
    path: '/mobile/:id',
    name: 'mobileLayout',
    component: () => import(/* webpackChunkName: "mobileLayout" */ '@/views/mobileLayout/index'),

  },
  ...customizedRoute,
]

//  createWebHistory(process.env.BASE_URL) base:'/yckf/',
const router = createRouter({
  base: process.env.VUE_APP_BASE_URL,
  history: createWebHistory(process.env.VUE_APP_ROUTER_BASE),
  // history:createWebHistory(process.env.BASE_URL),
  routes
})
console.log(router, 'router');

export default router
